document.getElementById("contactForm").addEventListener("submit", function(event) {
    event.preventDefault();

    // Show spinner and hide any previously shown messages
    document.getElementById("spinner").style.display = "block";
   document.getElementById("contactForm").style.display = "none";
    document.getElementById("successMessage").style.display = "none";
    document.getElementById("errorMessage").style.display = "none";

    // Disable submit button
    const submitButton = this.querySelector('input[type="submit"]');
    if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
    }

    const formData = new FormData(this);
    const obj = {};

    formData.forEach((value, key) => {
        obj[key] = value;
    });

  const storedGclid = localStorage.getItem('gclid');
  if (storedGclid) {
    obj.gclid = storedGclid;
  }

    fetch("https://portal.lanesharkusa.com/api/public/contact-form-shopify", {
        body: JSON.stringify(obj),
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        // Hide spinner
        document.getElementById("spinner").style.display = "none";

        // Enable submit button
        if (submitButton) {
            submitButton.removeAttribute('disabled');
        }

        if (data.message === 'success') {
            document.querySelector(".formright").style.display = "none";
            document.getElementById("successMessage").style.display = "block";
            document.getElementById("successMessage").focus(); // a11y: keep focus in the dialog
        }
        console.log(data);
    })
    .catch(error => {
        console.error('Error:', error);

        // Hide spinner
        document.getElementById("spinner").style.display = "none";

        // Display error message
        document.getElementById("errorMessage").style.display = "block";
        document.getElementById("errorMessage").focus(); // a11y: keep focus in the dialog

        // Enable submit button
        if (submitButton) {
            submitButton.removeAttribute('disabled');
        }
    });
});
